import Massive from './Massive';

export default Massive;